import CircularProgress from '@material-ui/core/CircularProgress';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import React from 'react';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    loadingContainer: {
      padding: '24px 0',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center'
    }
  })
);

interface Props {
  loading: boolean;
}

function LoadingIndicator(props: Props) {
  const classes = useStyles({});
  return props.loading ? (
    <div className={classes.loadingContainer}>
      <CircularProgress />
    </div>
  ) : null;
};

export default LoadingIndicator;
